import { Divider, Stack, Typography, colors } from '@mui/material';
import { decode } from 'jsonwebtoken';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import Cookies from 'universal-cookie';

const PortalHeader = ({ userInfo }) => {
  const navigate = useNavigate();
  const cookies = new Cookies();
  const decoded = decode(cookies.get('token'));
  const doLogOut = () => {
    cookies.remove('token', { path: '/' });
    window.location.href = '/auth';
  };

  const isTokenExpired = () => {
    const decodedToken = decode(cookies.get('token'));
    const expirationTime = decodedToken?.exp;
    const currentTime = Math.floor(Date.now() / 1000);

    if (currentTime >= expirationTime) doLogOut();
  };

  React.useEffect(() => {
    isTokenExpired();
  }, []);

  const getTypeText = (value) => {
    if (!value) return '';
    let text = '';
    text = value?.charAt(0).toUpperCase() + value.slice(1);
    if (value === 'verificator') text = 'Reviewer';

    return text || '-';
  };
  return (
    <Stack spacing={2}>
      <Divider />
      {/* {JSON.stringify(userInfo)} */}
      <Stack sx={{ backgroundColor: colors.grey[200], borderRadius: 2 }} py={3} px={4}>
        <Typography variant='h5'>Portal</Typography>
        <Stack direction='column' spacing={1}>
          <Stack direction='row' justifyContent='space-between'>
            <Stack direction='row' spacing={1}>
              <Typography variant='body2' sx={{ fontWeight: '700' }}>
                {userInfo.name || userInfo?.metadata?.first_name}
              </Typography>
              <Typography variant='body2'>-</Typography>
              <Typography variant='body2'>{getTypeText(userInfo.type)}</Typography>
              {/* <Typography variant='body2'>|</Typography>
            <Typography
              onClick={() => navigate(`/portal/my-profile/${decoded.username}`)}
              variant='body2'
              sx={{ fontWeight: 'bold', color: colors.blue[400], cursor: 'pointer' }}
            >
              Profile
            </Typography> */}
            </Stack>

            <Typography variant='body2' onClick={doLogOut} sx={{ fontWeight: 'bold', cursor: 'pointer', color: colors.red[400] }}>
              Logout
            </Typography>
          </Stack>
        </Stack>
      </Stack>
    </Stack>
  );
};

export default PortalHeader;
